import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import {OmContainer} from './OmContainer';
import {MblStatusViewModel} from "./MblStatusViewModel";
import {FileLockProp, InvoiceBillCrdb, RelatedCrdbDefinition} from "../ifmsTypes";
import {OeHbl} from './OeHbl';
import { CrDbHd } from './CrDbHd';
import _ from 'lodash';
import { appendLine } from '../util';

export class OeMbl extends TrackableEntity {
    modelName:string = "oembl"; //for ifmsButton > getChangedListData

    directBl: boolean = false;
    shipmentType: string = '';
    refNo: string = '';
    branch: string = '';
    lotNo: string = '';
    bookingNo: string = '';
    svccNo: string = '';
    agent: number = 0;
    agentName: string = '';
    agentCHold: boolean = false;
    agent2: number = 0;
    agent2Name: string = '';
    agent3: number = 0;
    agent3Name: string = '';
    mblCustomer: number = 0;
    mblCustomerName: string = '';
    carrier: number = 0;
    carrierName: string = '';
    mblNo: string = '';
    sMblNo: string = '';
    steamShip: number = 0;
    steamShipName: string = '';
    vessel: string = '';
    voyage: string = '';
    rstation: number = 0;
    rstationName: string = '';
    plofRec: string = '';
    plofDel: string = '';
    finalDestination: string = '';
    unlCode: string = '';
    uslCode: string = '';
    etd: string | null = null;
    loadingPort: string = '';
    undCode: string = '';
    usdCode: string = '';
    eta: string | null = null;
    discharge: string = '';
    ppcc: string = '';
    lclfcl: string = '';
    brokerage: number = 0;
    blType: string = '';
    profitShare: number = 0;
    moveType: string = '';
    cutoffDate: string | null = null;
    codeDesc: string = '';
    coLoad: string = '';
    showAgent: boolean = false;
    msManID: string = '';
    fileClosed: number = 0;
    isFileClosed: boolean = false;
    closedBy: string = '';
    closeDate: string | null = null;
    actClosed: boolean = false;
    actClosedBy: string = '';
    actCloseDate: string | null = null;
    postDate: string | null = null;
    line: string = '';
    shipper: number = 0;
    shipperName: string = '';
    consignee: number = 0;
    consigneeName: string = '';
    notify: number = 0;
    notifyName: string = '';
    forwardAgent: number = 0;
    forwardAgentName: string = '';
    mxtnNo: string = '';
    domesticInfo: string = '';
    hblNoCnt: number = 0;
    mark: string = '';
    markPkg: string = '';
    description: string = '';
    markOnboard: string = '';
    markGross: string = '';
    markMeasure: string = '';
    sName: string = '';
    cName: string = '';
    nName: string = '';
    fName: string = '';
    id: number = 0;
    u1Id: string = '';
    u1Date: string | null = null;
    u2Id: string = '';
    u2Date: string = '';
    operator: string = '';
    pimsLinkUserId: string = '';
    pimsLinkId: number = 0;
    pimsLinkDate: string | null = null;
    cur1: string = '';
    cur2: string = '';
    exrate1: number = 0;
    exrate2: number = 0;
    completeBill: string = '';
    completeInvo: string = '';
    completeCrDb: string = '';
    sentAgentEdi: string = '';
    confirmDate: string | null = null;
    confirmedBy: string = '';
    statusInfo: string = '';
    statusCrDb: string = '';
    confirmActionDate: string | null = null;
    dutyCustomer: number = 0;
    dutyCustomerName: string = '';
    dutyAgent: number = 0;
    dutyAgentName: string = '';
    scac: string = '';
    agentPimsId: number = 0;
    aaid: number = 0;
    rrid: number = 0;
    container: OmContainer[] = [];
    mblCustomer2: number = 0;
    mblCustomer2Name: string = '';
    commodity: string = '';
    agentRefNo: string = '';
    truckCom: number = 0;
    truckComName: string = '';
    cBookDate: string | null = null;
    sedCutoff: string | null = null;
    emptyPuLocId: number = 0;
    emptyPuLoc: string = '';
    statusInvo: string = '';
    statusBill: string = '';
    hblList: OeHbl[] = [];

    invoiceBill: InvoiceBillCrdb|null = null;
    readonlyCrdbLineItems?: Array<CrDbHd>|null = null;
    relatedCrdbDefinitions: Array<RelatedCrdbDefinition>|null = null;

    milestone: MblStatusViewModel|null = null;
    milestoneContainerSelectedIndex: number = 0;

    sendDocPkg: boolean = false;
    projectNo: string = '';

    get canChangeBranch():boolean {
        if (this.id <= 0) {
            return true;
        }

        const allowedStatuses = ['', 'E', 'D'];
        return allowedStatuses.includes(this.statusBill) &&
            allowedStatuses.includes(this.statusInvo) &&
            allowedStatuses.includes(this.statusCrDb) &&
            this.hblList.every(h => allowedStatuses.includes(h.statusBill) && allowedStatuses.includes(h.statusInvo) && allowedStatuses.includes(h.statusCrDb))
    };

    // UI only
    bookingId: number = 0;

    static fileLockEnableProps: FileLockProp[] = [
        { key: 'vessel', name: '' },
        { key: 'voyage', name: '' },
        { key: 'mark', name: '' },
        { key: 'markPkg', name: '' },
        { key: 'markGross', name: '' },
        { key: 'markMeasure', name: '' },
        { key: 'description', name: '' },
        { key: 'markOnBoard', name: '' },
    ];

    static fileLockMessage: string =
    `Vessel Name & Voyage
Container Information
B/L Body
`;

    constructor(init?:Partial<OeMbl>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('sendDocPkg, agentCHold', 'agent2Name', 'agent3Name', 'shipperName', 'consigneeName', 'notifyName', 'forwardAgentName', 'hblNoCnt', 'id', 'invoiceBill', 'hblList', 'bookingId', 'canChangeBranch', 'actClosed', 'actClosedBy', 'actCloseDate', 'confirmDate', 'confirmedBy');
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();

        if(this.container.length > 0) {
            this.container = this.container.map(d => new OmContainer(d));
        } else {
            this.container = [];
        }
    }

    isFileLockFor(propName: string) {
        return this.fileClosed > 0 && !OeMbl.fileLockEnableProps.some(x => x.key === propName);
    }
    
    static getFileLockMessage(): string {
        const messageBase = appendLine("OP Close", "The following fields are editable only:\n")
        // return appendLine(messageBase, OeMbl.fileLockEnableProps
        //     .map(x => x.name)
        //     .reduce((acc: string, x) => appendLine(acc, `\t${x}`), ""));
        return appendLine(messageBase, OeMbl.fileLockMessage);
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(OeMbl.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = OeMbl.dicFieldMappings[m];
        });

        _.keys(OmContainer.dicFieldMappings).forEach(m=>{
            dicFieldMap[`container.${m}`] = OmContainer.dicFieldMappings[m];
        });
        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'directBl': new DBMappingInfo({ field: 'F_DIRECTBL', table: 'T_OOMMAIN' }),
        'shipmentType': new DBMappingInfo({ field: 'F_SHIPMENTTYPE', table: 'T_OOMMAIN' }),
        'refNo': new DBMappingInfo({ field: 'F_REFNO', table: 'T_OOMMAIN' }),
        'branch': new DBMappingInfo({ field: 'F_BRANCH', table: 'T_OOMMAIN' }),
        'lotNo': new DBMappingInfo({ field: 'F_LOTNO', table: 'T_OOMMAIN' }),
        'bookingNo': new DBMappingInfo({ field: 'F_BOOKINGNO', table: 'T_OOMMAIN' }),
        'svccNo': new DBMappingInfo({ field: 'F_SVCCNO', table: 'T_OOMMAIN' }),
        'agent': new DBMappingInfo({ field: 'F_AGENT', table: 'T_OOMMAIN' }),
        'agent2': new DBMappingInfo({ field: 'F_AGENT2', table: 'T_OOMMAIN' }),
        'agent3': new DBMappingInfo({ field: 'F_AGENT3', table: 'T_OOMMAIN' }),
        'mblCustomer': new DBMappingInfo({ field: 'F_MBLCUSTOMER', table: 'T_OOMMAIN' }),
        'carrier': new DBMappingInfo({ field: 'F_CARRIER', table: 'T_OOMMAIN' }),
        'mblNo': new DBMappingInfo({ field: 'F_MBLNO', table: 'T_OOMMAIN' }),
        'sMblNo': new DBMappingInfo({ field: 'F_SMBLNO', table: 'T_OOMMAIN' }),
        'steamShip': new DBMappingInfo({ field: 'F_STEAMSHIP', table: 'T_OOMMAIN' }),
        'vessel': new DBMappingInfo({ field: 'F_VESSEL', table: 'T_OOMMAIN' }),
        'voyage': new DBMappingInfo({ field: 'F_VOYAGE', table: 'T_OOMMAIN' }),
        'rstation': new DBMappingInfo({ field: 'F_RSTATION', table: 'T_OOMMAIN' }),
        'plofRec': new DBMappingInfo({ field: 'F_PLOFREC', table: 'T_OOMMAIN' }),
        'plofDel': new DBMappingInfo({ field: 'F_PLOFDEL', table: 'T_OOMMAIN' }),
        'finalDestination': new DBMappingInfo({ field: 'F_FINALDESTINATION', table: 'T_OOMMAIN' }),
        'unlCode': new DBMappingInfo({ field: 'F_UNLCODE', table: 'T_OOMMAIN' }),
        'uslCode': new DBMappingInfo({ field: 'F_USLCODE', table: 'T_OOMMAIN' }),
        'etd': new DBMappingInfo({ field: 'F_ETD', table: 'T_OOMMAIN' }),
        'loadingPort': new DBMappingInfo({ field: 'F_LOADINGPORT', table: 'T_OOMMAIN' }),
        'undCode': new DBMappingInfo({ field: 'F_UNDCODE', table: 'T_OOMMAIN' }),
        'usdCode': new DBMappingInfo({ field: 'F_USDCODE', table: 'T_OOMMAIN' }),
        'eta': new DBMappingInfo({ field: 'F_ETA', table: 'T_OOMMAIN' }),
        'discharge': new DBMappingInfo({ field: 'F_DISCHARGE', table: 'T_OOMMAIN' }),
        'ppcc': new DBMappingInfo({ field: 'F_PPCC', table: 'T_OOMMAIN' }),
        'lclfcl': new DBMappingInfo({ field: 'F_LCLFCL', table: 'T_OOMMAIN' }),
        'brokerage': new DBMappingInfo({ field: 'F_BROKERAGE', table: 'T_OOMMAIN' }),
        'blType': new DBMappingInfo({ field: 'F_BLTYPE', table: 'T_OOMMAIN' }),
        'profitShare': new DBMappingInfo({ field: 'F_PROFITSHARE', table: 'T_OOMMAIN' }),
        'moveType': new DBMappingInfo({ field: 'F_MOVETYPE', table: 'T_OOMMAIN' }),
        'cutoffDate': new DBMappingInfo({ field: 'F_CUTOFFDATE', table: 'T_OOMMAIN' }),
        'coLoad': new DBMappingInfo({ field: 'F_COLOAD', table: 'T_OOMMAIN' }),
        'showAgent': new DBMappingInfo({ field: 'F_SHOWAGENT', table: 'T_OOMMAIN' }),
        'msManID': new DBMappingInfo({ field: 'F_MSMANID', table: 'T_OOMMAIN' }),
        'operator': new DBMappingInfo({ field: 'F_Operator', table: 'T_OOMMAIN' }),
        'fileClosed': new DBMappingInfo({ field: 'F_FILECLOSED', table: 'T_OOMMAIN' }),
        'closedBy': new DBMappingInfo({ field: 'F_CLOSEDBY', table: 'T_OOMMAIN' }),
        'postDate': new DBMappingInfo({ field: 'F_POSTDATE', table: 'T_OOMMAIN' }),
        'shipper': new DBMappingInfo({ field: 'F_SHIPPER', table: 'T_OOMMAIN' }),
        'consignee': new DBMappingInfo({ field: 'F_CONSIGNEE', table: 'T_OOMMAIN' }),
        'notify': new DBMappingInfo({ field: 'F_NOTIFY', table: 'T_OOMMAIN' }),
        'forwardAgent': new DBMappingInfo({ field: 'F_FORWARDAGENT', table: 'T_OOMMAIN' }),
        'mxtnNo': new DBMappingInfo({ field: 'F_MXTNNO', table: 'T_OOMMAIN' }),
        'domesticInfo': new DBMappingInfo({ field: 'F_DOMESTICINFO', table: 'T_OOMMAIN' }),
        'mark': new DBMappingInfo({ field: 'F_MARK', table: 'T_OOMMAIN' }),
        'markPkg': new DBMappingInfo({ field: 'F_MARKPKG', table: 'T_OOMMAIN' }),
        'description': new DBMappingInfo({ field: 'F_DESCRIPTION', table: 'T_OOMMAIN' }),
        'markOnboard': new DBMappingInfo({ field: 'F_MARKONBOARD', table: 'T_OOMMAIN' }),
        'markGross': new DBMappingInfo({ field: 'F_MARKGROSS', table: 'T_OOMMAIN' }),
        'markMeasure': new DBMappingInfo({ field: 'F_MARKMEASURE', table: 'T_OOMMAIN' }),
        'sName': new DBMappingInfo({ field: 'F_SNAME', table: 'T_OOMMAIN' }),
        'cName': new DBMappingInfo({ field: 'F_CNAME', table: 'T_OOMMAIN' }),
        'nName': new DBMappingInfo({ field: 'F_NNAME', table: 'T_OOMMAIN' }),
        'fName': new DBMappingInfo({ field: 'F_FNAME', table: 'T_OOMMAIN' }),
        'cur1': new DBMappingInfo({ field: 'F_CUR1', table: 'T_OOMMAIN' }),
        'cur2': new DBMappingInfo({ field: 'F_CUR2', table: 'T_OOMMAIN' }),
        'exrate1': new DBMappingInfo({ field: 'F_EXRATE1', table: 'T_OOMMAIN' }),
        'exrate2': new DBMappingInfo({ field: 'F_EXRATE2', table: 'T_OOMMAIN' }),
        'completeBill': new DBMappingInfo({ field: 'F_COMPLETEBILL', table: 'T_OOMMAIN' }),
        'completeInvo': new DBMappingInfo({ field: 'F_COMPLETEINVO', table: 'T_OOMMAIN' }),
        'completeCrDb': new DBMappingInfo({ field: 'F_COMPLETECRDB', table: 'T_OOMMAIN' }),
        'dutyCustomer': new DBMappingInfo({ field: 'F_DUTYCUSTOMER', table: 'T_OOMMAIN' }),
        'dutyAgent': new DBMappingInfo({ field: 'F_DUTYAGENT', table: 'T_OOMMAIN' }),
        'sentAgentEdi': new DBMappingInfo({ field: 'F_SentAgentEDI', table: 'T_OOMMAIN' }),
        'line': new DBMappingInfo({ field: 'F_Line', table: 'T_OOMMAIN' }),
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_OOMMAIN' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1ID', table: 'T_OOMMAIN' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_OOMMAIN' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_OOMMAIN' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_OOMMAIN' }),
        'mblCustomer2': new DBMappingInfo({ field: 'MBLCustomer2', table: 'T_OOMMAIN' }),
        'commodity': new DBMappingInfo({ field: 'Commodity', table: 'T_OOMMAIN' }),
        'agentRefNo': new DBMappingInfo({ field: 'AgentRefNo', table: 'T_OOMMAIN' }),
        'truckCom': new DBMappingInfo({ field: 'TruckCom', table: 'T_OOMMAIN' }),
        'cBookDate': new DBMappingInfo({ field: 'CBookDate', table: 'T_OOMMAIN' }),
        'sedCutoff': new DBMappingInfo({ field: 'SedCutoff', table: 'T_OOMMAIN' }),
        'emptyPuLoc': new DBMappingInfo({ field: 'EmptyPuLoc', table: 'T_OOMMAIN' }),
        'emptyPuLocId': new DBMappingInfo({ field: 'EmptyPuLocId', table: 'T_OOMMAIN' }),
        'projectNo': new DBMappingInfo({field:'ProjectNo', table:'T_OOMMAIN'}),

    };

    setChildTrackable(value: boolean): void {
        if(this.container.length > 0) {
            this.container.forEach(c => c.trackable = value);
        }
    }
}
